import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import {
  Flex,
  GreyGrey80,
  Primary13Regular,
  SimpleModal
} from '@sequencehq/core-components'
import { FC } from 'react'
import { IntegrationCustomerSelect } from 'Integrations/components/integrationCustomerPicker'
import { useLinkCustomerModal } from './useLinkCustomerModal'
import { IntegrationCustomerTypeahead } from '../IntegrationCustomerTypeahead'
import { ExternalAccountDetails } from './ExternalAccountDetails'

export const LinkCustomerModal: FC<{
  onLink?: () => void
  onClose: () => void
  customerId: string
  service: IntegrationServices | 'Attio'
}> = props => {
  const hook = useLinkCustomerModal({
    onConfirm: props.onLink,
    customerId: props.customerId,
    service: props.service
  })

  return (
    <SimpleModal
      isOpen
      onClose={props.onClose}
      data-testid="modal.linkCustomer"
      title={`Link ${hook.customerName} to ${hook.serviceName} customer`}
      isLoading={!hook.loaded}
      submitButtonText="Create link"
      submittingButtonText="Creating link..."
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      submitting={hook.submit.linking}
      onSubmit={hook.submit.onClick}
      minHeight="0px"
    >
      <Flex
        color={GreyGrey80}
        {...Primary13Regular}
        flexDirection="column"
        gap="16px"
      >
        {hook.searchesCustomers ? (
          <IntegrationCustomerTypeahead
            label={`${hook.serviceName} customer`}
            service={props.service}
            serviceName={hook.serviceName}
            value={hook.fields.linkToAccount.value}
            onChange={hook.fields.linkToAccount.onChange}
            data-testid="linkToAccount"
          />
        ) : (
          <>
            <IntegrationCustomerSelect
              label={`${hook.serviceName} customer`}
              customers={hook.select.customers}
              value={hook.fields.linkToAccount.value}
              onChange={hook.fields.linkToAccount.onChange}
              integrationName={hook.serviceName}
              unfilteredCustomerCount={hook.select.unfilteredCustomerCount}
              allCustomersLinked={hook.select.allCustomersLinked}
              data-testid="linkToAccount"
            />

            {hook.externalAccountDetails && (
              <ExternalAccountDetails
                name={hook.externalAccountDetails.name}
                externalUrl={hook.externalAccountDetails.externalUrl}
                serviceName={hook.serviceName}
              />
            )}
          </>
        )}
      </Flex>
    </SimpleModal>
  )
}
